export default __webpack_public_path__ + "static/race-day-5k-vertical-f924c7c0e100555df9aff6f004f42896.png";